import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import Button from '@starbucks-web/pattern-library/lib/components/button';
import { sharedCallsToAction } from 'shared/app/messages/ctas';
import { trackBarcodeCardManageClick } from '../../state/actions/track-event';

const ManageCardLink = ({ cardId, className, ...otherProps }) => {
  return (
    <Button
      className={`${className || ''}`}
      data-e2e="manageCardLink"
      onClick={() => {
        trackBarcodeCardManageClick();
      }}
      tagName={Link}
      to={`/account/cards/${cardId}`}
      visualStyle="textOnly"
      {...otherProps}
    >
      <FormattedMessage {...sharedCallsToAction.manage} />
    </Button>
  );
};

ManageCardLink.propTypes = {
  cardId: PropTypes.string.isRequired,
};

export default ManageCardLink;
